<template>
  <v-dialog
    v-model="display"
    max-width="600"
    :persistent="busy"
  >
    <v-card v-if="display">
      <v-card-title class="subtitle-1 font-weight-light">
        Are you sure you want to delete <strong class="ml-1">{{ group.name }}</strong>?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          text
          id="admin-groups-delete-cancel-btn"
          color="info"
          :disabled="busy"
          @click="() => display = false"
        >
          Cancel
        </v-btn>

        <v-btn
          text
          id="admin-groups-delete-confirm-btn"
          color="error"
          :loading="busy"
          @click="submit"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
export default {
  name: 'AdminGroupsDeleteModal',
  data: () => ({
    display: false,
    group: null,
    busy: false,
  }),
  methods: {
    open(group) {
      if (!group) { return; }
      this.group = group;
      this.display = true;
    },
    submit() {
      this.busy = true;

      this.$requests.delete(`/v1/groups/${this.group._id}`)
        .then(() => {
          this.$toast.success(`Deleted group ${this.group.name}`, { timeout: 3000 });
          this.display = false;
          this.$emit('success');
        })
        .catch(err => {
          this.$toast.error(err.response.data?.message || `Could not delete ${this.group.name}...`, { timeout: 3000 });
        })
        .then(() => { this.busy = false; });
    },
  },
  watch: {
    display(val) {
      if (!val) {
        this.group = null;
      }
    },
  },
};
</script>
